import { PropsWithChildren, ReactElement } from "react";

import { Box, Grid, GridItem } from "@chakra-ui/react";

import { Panel, PanelGroup } from "@/components/factories/react-resizable-panels";
import { INFO_BAR_WIDTH } from "@/constants/sizes";

export interface BaseGridProps {
  BottomPanel?: ReactElement;
  LeftSidebar?: ReactElement;
  RightSidebar?: ReactElement;
}

export default function BaseGrid({
  children,
  BottomPanel,
  LeftSidebar,
  RightSidebar,
}: PropsWithChildren<BaseGridProps>) {
  return (
    <PanelGroup autoSaveId="fullLayout" direction="vertical" h="full">
      <Panel id="mainPanel">
        <Grid
          gap={0}
          h="full"
          overflow="auto"
          templateColumns={{
            xl: `auto 1fr ${INFO_BAR_WIDTH}`,
            base: "1fr",
          }}
          templateRows={{
            xl: "1fr auto",
          }}
        >
          <GridItem display={{ base: "none", xl: "block" }} h="full" overflow="auto" tabIndex={0}>
            {LeftSidebar}
          </GridItem>
          <GridItem h="full" overflow="hidden" pt={{ base: 10, xl: 0 }}>
            {children}
          </GridItem>
          <GridItem display={{ base: "none", xl: "block" }}>
            {RightSidebar && <Box h="full">{RightSidebar}</Box>}
          </GridItem>
        </Grid>
      </Panel>
      {BottomPanel}
    </PanelGroup>
  );
}
